export default "__VITE_ASSET__CyyvOCVU__"